import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Client } from "../../api-client";
import { TABLE_ROWS_COUNT } from "../../../shared/constants";
import {
  API_APPROVE_PROJECT,
  API_REJECT_PROJECT,
  API_CREATE_PROJECT,
  API_CREATE_STAFF_ASSIGNMENT,
  API_DELETE_PROJECT,
  API_GET_PROJECT_LIST,
  API_GET_STAFF_ALLOCATION,
  API_GET_STAFF_ASSIGNMENT_SUMMARY,
  API_PROJECT_BULK_IMPORT,
  API_UPDATE_PROJECT,
  API_UPDATE_STAFF_ASSIGNMENT,
  API_SOFT_DELETE_STAFF_PROJECT,
} from "../../../shared/routes/private.routes";

const config = {
  name: "project",
};
export const getProjectList: any = createAsyncThunk(
  `${config.name}/getProjectList`,
  async ({ params, body }: any) => {
    return Client.post(API_GET_PROJECT_LIST, body, { params });
  }
);
export const deleteProjectById: any = createAsyncThunk(
  `${config.name}/deleteProject`,
  async (projectId: any) => {
    return Client.delete(API_DELETE_PROJECT + projectId);
  }
);
export const createProject: any = createAsyncThunk(
  `${config.name}/createProject`,
  async (formData: FormData) => {
    return Client.post(API_CREATE_PROJECT, formData);
  }
);
export const approveProject: any = createAsyncThunk(
  `${config.name}/approveProject`,
  async (projectId: string) => {
    return Client.patch(API_APPROVE_PROJECT + `${projectId}`, {});
  }
);

export const rejectProject: any = createAsyncThunk(
  `${config.name}/rejectProject`,
  async (projectId: string) => {
    return Client.patch(API_REJECT_PROJECT + `${projectId}`, {});
  }
);

export const updateProjectById: any = createAsyncThunk(
  `${config.name}/updateProject`,
  async ({
    projectId,
    formData,
  }: {
    projectId: string;
    formData: FormData;
  }) => {
    return Client.put(API_UPDATE_PROJECT + projectId, formData);
  }
);

export const getStaffAssignments: any = createAsyncThunk(
  `${config.name}/get-staff-assignments`,
  async (projectId: string) => {
    return Client.get(API_GET_STAFF_ALLOCATION + `${projectId}`);
  }
);

export const createStaffAssignment: any = createAsyncThunk(
  `${config.name}/create-staff-assignments`,
  async (body: any) => {
    return Client.post(API_CREATE_STAFF_ASSIGNMENT, body);
  }
);

export const updateStaffAssignment: any = createAsyncThunk(
  `${config.name}/updateProject`,
  async (body: any) => {
    return Client.put(API_UPDATE_STAFF_ASSIGNMENT, body);
  }
);

export const softDeleteStaffProjectAssignments: any = createAsyncThunk(
  `${config.name}/soft-delete-staff-project`,
  async (body: { staffId: string; projectId: string }) => {
    return Client.post(API_SOFT_DELETE_STAFF_PROJECT, body);
  }
);

export const getStaffAssignmentSummary: any = createAsyncThunk(
  `${config.name}/getStaffAssignmentSummary`,
  async ({params, body}: any) => {
    return Client.post(API_GET_STAFF_ASSIGNMENT_SUMMARY, body);
  }
);

export const projectBulkImport: any = createAsyncThunk(
  `${config.name}/project-bulk-import`,
  async (file: any) => {
    return Client.post(API_PROJECT_BULK_IMPORT, file);
  }
); 

export const projectReducer = createSlice({
  name: config.name,
  initialState: {
    loadingProject: false as any,
    projectList: [] as any,
    filters: {} as any,
    pagination: { page: 0, limit: TABLE_ROWS_COUNT, total: 0 },
  },
  reducers: {
    resetProject: (state) => {
      state.loadingProject = false;
      state.projectList = [];
      state.filters = {};
      state.pagination = { page: 0, limit: TABLE_ROWS_COUNT, total: 0 };
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getProjectList.pending, (state) => {
        state.loadingProject = true;
        state.projectList = [] as any;
      })
      .addCase(getProjectList.fulfilled, (state, action) => {
        state.loadingProject = false;
        state.projectList = action?.payload?.data?.data as any;
        state.pagination = {
          page: action?.payload?.data?.page,
          limit: action?.payload?.data?.limit,
          total: action?.payload?.data?.total,
        };
      })
      .addCase(getProjectList.rejected, (state) => {
        state.loadingProject = false;
        state.projectList = [] as any;
      });
  },
});

export const { resetProject } = projectReducer.actions;
export default projectReducer.reducer;

